var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    style: {
      fill: "var(--content-1)",
      fontSize: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.46 15.682l-6.364-6.364 1.414-1.414a.998.998 0 000-1.415.999.999 0 00-1.414 0l-1.414 1.415L8.319 1.54a1 1 0 00-1.414 0L1.954 6.49a1 1 0 000 1.414l6.364 6.364-1.288 1.288-3.732.199c-.865.045-1.266 1.093-.655 1.705l3.898 3.898c.61.61 1.659.21 1.705-.655l.198-3.733 1.288-1.288 6.364 6.364a.998.998 0 001.415 0l4.949-4.95a.999.999 0 000-1.414zM4.075 7.197L7.612 3.66l5.656 5.657-3.535 3.536-5.658-5.657zm12.729 12.728l-5.657-5.657 3.535-3.536 5.657 5.657-3.535 3.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.8e167710ba384408040e3aba20945a86.svg";
export { ForwardRef as ReactComponent };